import {
  UPLOAD_DOCUMENT_REQUEST,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  CLEAR_DOCUMENT_ERRORS,    // Nouvelles imports
  CLEAR_DOCUMENT_SUCCESS,
} from './actionTypes';

const initialState = {
  loadingDoc: false,
  errorDoc: null,
  lastDocumentAdded: null,
};

const Documents = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        loadingDoc: true,
        errorDoc: null,
        lastDocumentAdded: null,
      };
    case UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingDoc: false,
        lastDocumentAdded: action.payload,
      };
    case UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        loadingDoc: false,
        errorDoc: action.payload,
      };
    case CLEAR_DOCUMENT_ERRORS:
      return {
        ...state,
        errorDoc: null,
      };
    case CLEAR_DOCUMENT_SUCCESS:
      return {
        ...state,
        lastDocumentAdded: null,
      };
      
    default:
      return state;
  }
};

export default Documents;